import { useState } from "react";
import { Alert, Button, Select, Space } from "antd";
import { Link } from "react-router-dom";
import { query } from "./api";
import type { Page, Task } from "./domain";
import type { TaskBusiness } from "./business";
import { useResource } from "./shared";

export function TaskNameSelect({ id, value, onChange, business, placeholder = "搜索并选择任务" }: {
  id?: string; value?: number; onChange?: (value?: number) => void; business?: TaskBusiness; placeholder?: string;
}) {
  const [search, setSearch] = useState("");
  const tasks = useResource<Page<Task>>(`/tasks${query({ business, search, page_size: 100 })}`);
  const selected = useResource<Task>(value ? `/tasks/${value}` : null);
  const options = (tasks.data?.items || []).map(task => ({ value: task.id, label: task.payload.title || "未命名任务" }));
  if (value && !options.some(option => option.value === value)) {
    options.unshift({ value, label: selected.data?.id === value ? selected.data.payload.title : selected.error ? "任务名称暂不可用" : "正在加载任务名称…" });
  }
  const failed = tasks.error || selected.error;
  return <Space direction="vertical" style={{ width: "100%", minWidth: 200 }}>
    <Select id={id} style={{ width: "100%" }} value={value} onChange={onChange} placeholder={placeholder} allowClear showSearch filterOption={false} onSearch={setSearch} onClear={() => setSearch("")} loading={tasks.loading || selected.loading} options={options} notFoundContent={tasks.loading ? "正在加载…" : "没有匹配的任务"} />
    {failed && <Alert type="warning" showIcon message="任务名称加载失败" action={<Button size="small" onClick={() => { void tasks.reload(); void selected.reload(); }}>重试</Button>} />}
  </Space>;
}

export function TaskNameLink({ id }: { id: number }) {
  const task = useResource<Task>(`/tasks/${id}`);
  return <><Link to={`/tasks/${id}`}>{task.data?.id === id ? task.data.payload.title : task.error ? "任务名称暂不可用" : "正在加载任务名称…"}</Link>{task.error && <Button type="link" size="small" onClick={() => void task.reload()}>重试</Button>}</>;
}
